import React from 'react';
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, combineReducers } from "redux";

import Login from "./Components/login.component";
import Main from "./Components/home.component";
import AuthRoute from "./Components/AuthRoute";
import { appMiddleware } from "./Middlewares/app";
import { apiMiddleware } from "./Middlewares/core";
import reducer from "./reducer";
import themeReducer from "./reducers/index";
import Loader from './Loading';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './assets/base.css'
// import history from './history';

// used for dev tools monitoring
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxPromise from "redux-promise";
import 'alertifyjs/build/css/alertify.css'


const createStoreWithMiddleware = applyMiddleware(
	appMiddleware,
	apiMiddleware,
)(createStore);

const rootReducer = combineReducers({reducer, ThemeOptions:themeReducer.ThemeOptions});

const store = createStoreWithMiddleware(rootReducer, composeWithDevTools(applyMiddleware(ReduxPromise)));

function App(props) {
	console.log("REDNERING APP.JS")
	return (
		<Provider store={store}>
			<Router >
				<div className="App">

					{/* <div className="container-fluid"> */}
					<Switch>

						<Redirect exact from='/' to='/login' />
						{/* <Route path='/' component={Login}/> */}
						<AuthRoute path="/login" component={Login} type="guest" />
						{/* <Route path="/sign-up" component={SignUp} /> */}
						<AuthRoute path="/main" component={Main} type="private" {...props}/>
						{/* <Route path="/blogs" component={Blogs} /> */}
					</Switch>
				</div>
				{/* </div> */}
			</Router>
			<Loader />
		</Provider>
	);
}


export default App;